import React, { useCallback, useEffect, useState } from 'react';
import { Form, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { SPRINT_CLAIM_NAME } from '@rd-web-markets/market/dist/constants';
import CompanyClaimGroupEditForm from './CompanyClaimGroupEditForm';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Button, SaveButton } from '../util/buttons';
import { setLoading } from '../store/features/uiSlice';
import { setHasImportantUnsavedChanges } from '../store/features/unsavedChangesSlice';
const CompanyEditForm = _ref => {
  let {
    removeConsultantFromClaim,
    claimTemplates,
    selectedCompany,
    handleSubmit,
    managers = [],
    admins = [],
    consultants = [],
    loading,
    toggleForm,
    questionnaires,
    handleToaster,
    CompanyMarketRelatedFields,
    contracts
  } = _ref;
  const [company, setCompany] = useState(selectedCompany);
  const [finalizedClaims, setFinalizedClaims] = useState(company.claims);
  const [defaultTemplate, setDefaultTemplate] = useState(null);
  const [tasks, setTasks] = useState([]);
  const dispatch = useDispatch();
  const user = useSelector(state => state.auth.user);
  const {
    t
  } = useTranslation();
  const handleChange = event => {
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    dispatch(setHasImportantUnsavedChanges(true));
    setCompany({
      ...company,
      [event.target.name]: value
    });
  };
  useEffect(() => {
    setCompany(prevCompany => ({
      ...prevCompany,
      id: selectedCompany.id
    }));
  }, [selectedCompany]);
  const submit = e => {
    e.preventDefault();
    handleSubmit({
      ...company,
      claims: finalizedClaims,
      claim_template_tasks: tasks.filter(task => task.included === true)
    });
    dispatch(setHasImportantUnsavedChanges(false));
  };
  const onClaimsChangeSetFinalizedClaims = useCallback(claims => {
    dispatch(setHasImportantUnsavedChanges(true));
    setFinalizedClaims([...claims]);
  }, [dispatch]);
  const handleClaimTypeChange = e => {
    dispatch(setHasImportantUnsavedChanges(true));
    const template = claimTemplates.find(template => template.id === +e);
    const newTasks = [];
    template.claim_template_categories.forEach(category => {
      category.claim_template_tasks.forEach(task => newTasks.push({
        ...task,
        category_title: category.title,
        included: true
      }));
    });
    setTasks([...newTasks]);
  };
  useEffect(() => {
    const tasks = [];
    const defaultTemplate = claimTemplates.find(template => template.name === SPRINT_CLAIM_NAME);
    setDefaultTemplate(defaultTemplate);
    if (defaultTemplate) {
      defaultTemplate.claim_template_categories.forEach(category => {
        category.claim_template_tasks.forEach(task => tasks.push({
          ...task,
          category_title: category.title,
          included: true
        }));
      });
    }
    setTasks(tasks);
  }, [claimTemplates]);
  const updateTasks = tasks => {
    dispatch(setHasImportantUnsavedChanges(true));
    setTasks(tasks);
  };
  const handleClaimGroupChange = event => {
    dispatch(setHasImportantUnsavedChanges(true));
    const claimGroupCopy = company.claim_group;
    const value = event.target.value;
    claimGroupCopy[event.target.name] = value;
    setCompany({
      ...company,
      claim_group: claimGroupCopy
    });
  };
  const handleRadioButtonChange = event => {
    dispatch(setHasImportantUnsavedChanges(true));
    const claimGroupCopy = company.claim_group;
    const value = event.target.value === 'true' ? true : false;
    claimGroupCopy[event.target.name] = value;
    setCompany({
      ...company,
      claim_group: claimGroupCopy
    });
  };
  const lead_consultant_exists = claimGroup => {
    const consultants = company.claim_group.consultants || company.claim_group.consultants_attributes;
    return consultants.find(consultant => consultant.role === 'claim_group_access_lead_consultant');
  };
  const handleConsultantToClaimGroupCreate = consultant => {
    const consultantsAttributes = company.claim_group.consultants_attributes;
    if (!consultantsAttributes.find(cons => cons.id === consultant.id)) {
      if (consultant.role === 'claim_group_access_lead_consultant' && lead_consultant_exists(consultantsAttributes)) {
        handleToaster('Lead consultant already added', 'warning');
      } else {
        dispatch(setHasImportantUnsavedChanges(true));
        consultantsAttributes.push({
          id: consultant.id,
          email: consultant.email,
          name: consultant.name,
          role: consultant.role
        });
        setCompany({
          ...company,
          consultants_attributes: consultantsAttributes
        });
      }
    }
  };
  const changeContactClaimGroup = contact => {
    dispatch(setHasImportantUnsavedChanges(true));
    const contactsAttributes = company.claim_group.rnd_collaborate_contacts_attributes.filter(cont => cont.name !== contact.name);
    contactsAttributes.push({
      ...contact,
      claim_group_id: company.claim_group.id
    });
    setCompany({
      ...company,
      rnd_collaborate_contacts_attributes: contactsAttributes,
      claim_group: {
        ...company.claim_group,
        rnd_collaborate_contacts_attributes: contactsAttributes
      }
    });
  };
  const removeContactAttribute = contactName => {
    dispatch(setHasImportantUnsavedChanges(true));
    const contactsAttributes = company.claim_group.rnd_collaborate_contacts_attributes.filter(cont => cont.name !== contactName);
    setCompany({
      ...company,
      rnd_collaborate_contacts_attributes: contactsAttributes,
      claim_group: {
        ...company.claim_group,
        rnd_collaborate_contacts_attributes: contactsAttributes
      }
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form, {
    onSubmit: submit
  }, /*#__PURE__*/React.createElement(CompanyMarketRelatedFields, {
    setLoading: setLoading,
    company: company,
    setCompany: newCompany => {
      dispatch(setHasImportantUnsavedChanges(true));
      setCompany(newCompany);
    },
    handleChange: handleChange,
    handleToaster: handleToaster,
    contracts: contracts
  }), !company.id && /*#__PURE__*/React.createElement(CompanyClaimGroupEditForm, {
    managers: managers,
    admins: admins,
    changeContactClaimGroup: changeContactClaimGroup,
    removeContactAttribute: removeContactAttribute,
    claimGroupContacts: company.claim_group.rnd_collaborate_contacts_attributes,
    removeConsultantFromClaim: removeConsultantFromClaim,
    claimGroup: company.claim_group,
    handleClaimGroupChange: handleClaimGroupChange,
    handleRadioButtonChange: handleRadioButtonChange,
    tasks: tasks,
    claimTemplates: claimTemplates,
    defaultTemplate: defaultTemplate,
    handleClaimTypeChange: handleClaimTypeChange,
    updateTasks: updateTasks,
    onUpdateConsultants: handleConsultantToClaimGroupCreate,
    consultantsAndAdmins: [...consultants, ...managers, ...admins],
    questionnaires: questionnaires
  }), /*#__PURE__*/React.createElement(Row, {
    className: `modal-footer ${window.MARKET_CONSTANTS.COMPANY_BUTTONS_FORM_BOOTSTRAP_CLASS}`
  }, company.id ? /*#__PURE__*/React.createElement(Button, {
    loading: loading,
    variant: "light",
    as: Link,
    to: `/${user.account_type}/companies/${company.id}/master`
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, "chevron_left"), " ", t('back')) : /*#__PURE__*/React.createElement(Button, {
    variant: "light",
    onClick: () => toggleForm()
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, "chevron_left"), " ", t('back')), /*#__PURE__*/React.createElement(SaveButton, {
    isImmutableUnderReview: true,
    storeIsUnderReviewField: 'isAnyCompanyClaimGroupUnderTechnicalReview',
    loading: loading,
    text: t('save')
  }))));
};
export default CompanyEditForm;